import { PRECIOS } from "./precios";

/**
 * Campaña de temporada.
 *
 * NO ES LO MISMO QUE EL INCENTIVO. `data/incentivo.js` regala algo sobre el
 * precio de siempre — mismo producto, un extra con fecha. Una campaña es otra
 * cosa: producto propio, precio propio, público propio y foto propia. Por eso
 * vive en su archivo y no como un pack más de segmentos.js, donde heredaría
 * la tarifa por hora que esta oferta justamente no usa.
 *
 * SE APAGA SOLA. Pasado `HASTA`, el banner desaparece de la home sin que nadie
 * tenga que acordarse de sacarlo. Una campaña de Navidad todavía publicada en
 * marzo es la señal más clara de un sitio abandonado — y en este caso peor
 * que un incentivo vencido, porque ocupa un banner entero.
 *
 * PARA APAGARLA ANTES DE TIEMPO: deja `HASTA` en "".
 * PARA LA PRÓXIMA TEMPORADA: cambia `HASTA`, el copy y la foto. La estructura
 * sirve igual para el día de la madre o para una campaña de graduaciones.
 */

/** Último día en que la promoción vale, inclusive. Formato YYYY-MM-DD. */
export const HASTA = "2026-12-06";

/** Hoy en Chile. El UTC no sirve: adelanta el corte varias horas. */
const hoyEnChile = () =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Santiago",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());

export const campanaActiva = () => Boolean(HASTA) && hoyEnChile() <= HASTA;

/** "6 de diciembre", para el copy. */
export const hastaTexto = () =>
  new Intl.DateTimeFormat("es-CL", {
    timeZone: "America/Santiago",
    day: "numeric",
    month: "long",
  }).format(new Date(`${HASTA}T12:00:00Z`));

/**
 * La foto del banner.
 *
 * Misma forma que una foto del portafolio para que PhotoImage la pinte igual.
 * En `null` el banner se dibuja sin ella sobre el campo oscuro, sin romperse
 * ni dejar un hueco: el texto es lo que vende, la foto lo mejora.
 *
 * Lleva un ancho más que el portafolio — 2400 — porque el banner es a sangre
 * y en una pantalla grande el navegador pide más de 1600 px.
 */
const ANCHOS = [480, 960, 1600, 2400];
const BASE = "/fotografia/campanas/campanas-navidad-2026";

export const FOTO = {
  id: "campanas-navidad-2026",
  src: `${BASE}-1600.webp`,
  srcSet: ANCHOS.map((ancho) => `${BASE}-${ancho}.webp ${ancho}w`).join(", "),
  w: 4160,
  h: 2773,
  ratio: 0.6666,
  alt: "Niño sentado sobre una manta blanca entre un reno y un muñeco de nieve de peluche, junto a un árbol de Navidad decorado en rojo y plateado",
};

export const CAMPANA = {
  id: "navidad-2026",
  etiqueta: "Campaña de Navidad",
  nombre: "Mini Sesiones Navideñas",
  claim: "La Navidad pasa volando. Las fotos se quedan.",
  priceKey: "navidad",
  ivaIncluido: true,
  /* El volumen va junto al precio: es lo que lo hace comparable. */
  volumen: "15 fotos editadas",
  incluye: [
    "Sesión fotográfica personalizada",
    "Familia de 3 a 4 integrantes",
    "15 fotos editadas en alta calidad",
  ],
  whatsapp: `Hola Omega, quiero reservar una Mini Sesión Navideña de ${PRECIOS.navidad.toLocaleString(
    "es-CL"
  )}. ¿Qué fechas tienen?`,
};
